import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/Notificacion`

export function buscarPorMensaje(idUsuarioChat) {
  return http.get(`${API_ENDPOINT}/BuscarPorMensaje/${idUsuarioChat}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las notificaciones.',
      tipoError: 'notificacion'
    }
  })
}
export function actualizarNotificacion(idMensaje) {
  return http.put(API_ENDPOINT, idMensaje)
}
